/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegisterUser201Response
 */
export interface RegisterUser201Response {
    /**
     * 
     * @type {number}
     * @memberof RegisterUser201Response
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof RegisterUser201Response
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterUser201Response
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterUser201Response
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterUser201Response
     */
    role: RegisterUser201ResponseRoleEnum;
    /**
     * 
     * @type {number}
     * @memberof RegisterUser201Response
     */
    companyId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterUser201Response
     */
    firebaseUid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterUser201Response
     */
    accountStatus?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RegisterUser201Response
     */
    lastLoginAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof RegisterUser201Response
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof RegisterUser201Response
     */
    readonly updatedAt?: Date;
}


/**
 * @export
 */
export const RegisterUser201ResponseRoleEnum = {
    Owner: 'owner'
} as const;
export type RegisterUser201ResponseRoleEnum = typeof RegisterUser201ResponseRoleEnum[keyof typeof RegisterUser201ResponseRoleEnum];


/**
 * Check if a given object implements the RegisterUser201Response interface.
 */
export function instanceOfRegisterUser201Response(value: object): value is RegisterUser201Response {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function RegisterUser201ResponseFromJSON(json: any): RegisterUser201Response {
    return RegisterUser201ResponseFromJSONTyped(json, false);
}

export function RegisterUser201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterUser201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'email': json['email'],
        'name': json['name'] == null ? undefined : json['name'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'role': json['role'],
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
        'firebaseUid': json['firebaseUid'] == null ? undefined : json['firebaseUid'],
        'accountStatus': json['accountStatus'] == null ? undefined : json['accountStatus'],
        'lastLoginAt': json['lastLoginAt'] == null ? undefined : (new Date(json['lastLoginAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function RegisterUser201ResponseToJSON(json: any): RegisterUser201Response {
    return RegisterUser201ResponseToJSONTyped(json, false);
}

export function RegisterUser201ResponseToJSONTyped(value?: Omit<RegisterUser201Response, 'id'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'name': value['name'],
        'phone': value['phone'],
        'role': value['role'],
        'companyId': value['companyId'],
        'firebaseUid': value['firebaseUid'],
        'accountStatus': value['accountStatus'],
        'lastLoginAt': value['lastLoginAt'] == null ? undefined : ((value['lastLoginAt'] as any).toISOString()),
    };
}

